import React, {Component} from 'react';
import {BASENAME} from "../../constants";
import withMobileDialog from '@material-ui/core/withMobileDialog';
import {Parser} from 'html-to-react';
import Divider from '@material-ui/core/Divider';
import { trackPromise} from 'react-promise-tracker';

import ArtifactDialog from './ArtifactDialog';

class Attachment extends Component {
    htmlToReactParser = new Parser();

    constructor(props) {
        super(props);
        this.state = {
            public_url: null,
            url: '',
            oviewer_url : 'https://view.officeapps.live.com/op/embed.aspx?src=',
            numPages: null,
            pageNumber: 0,
            videoLoadError: false
        }
    }

    renderDescription() {
        return (
            <div>
                <h1>{this.props.submission.canvas_assignment_name}</h1>
                <hr/>
                <h2>Assignment Description</h2>
                <h3>
                    {this.htmlToReactParser.parse(this.props.submission.canvas_assignment_description.replace(/(\\r\\n|\\n|\\r)/gm," "))}
                </h3>
                <hr/>
            </div>
        );
    }

componentDidMount() {
        this.setState({ videoLoadError: false });

        const attachmentId = this.props.attachment.canvas_attachment_id;
        const url = BASENAME + '/api/getpublicurl/' + attachmentId;
        const streamUrl = BASENAME + '/api/stream/' + attachmentId;

        const contentType = (this.props.attachment.contentType || '').toLowerCase();
        const mimeClass = (this.props.attachment.mime_class || '').toLowerCase();
        const fileName = (
            this.props.attachment.filename ||
            this.props.attachment.display_name ||
            ''
        ).toLowerCase();

        const isVideo =
            contentType.startsWith('video/') ||
            mimeClass === 'video' ||
            fileName.endsWith('.mp4');

        if (isVideo) {
            this.setState({ public_url: streamUrl });
            return;
        }

        fetch(url)
            .then(res => {
                if (!res.ok) {
                    throw new Error('getpublicurl failed: ' + res.status);
                }
                return res.json();
            })
            .then(res => {
                const publicUrl = res.public_url || '';

                switch (contentType) {
                    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                    case 'application/msword':
                    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    case 'application/vnd.ms-excel':
                        this.setState({ public_url: this.state.oviewer_url + encodeURIComponent(publicUrl) });
                        break;
                    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                    case 'application/pdf':
                        this.setState({ public_url: 'https://docs.google.com/gview?url=' + encodeURIComponent(publicUrl) + '&embedded=true' });
                        break;
                    case 'image/jpeg':
                    case 'image/png':
                    default:
                        this.setState({ public_url: publicUrl });
                }
            })
            .catch(() => {
                this.setState({ public_url: null });
            });
    }

    showIframe() {
        if (this.state.public_url) {
            const contentType = (this.props.attachment.contentType || '').toLowerCase();
            const mimeClass = (this.props.attachment.mime_class || '').toLowerCase();
            const fileName = (
                this.props.attachment.filename ||
                this.props.attachment.display_name ||
                ''
            ).toLowerCase();
            const isVideo =
                contentType.startsWith('video/') ||
                mimeClass === 'video' ||
                fileName.endsWith('.mp4');
            const sourceType = contentType || 'video/mp4';

            return (
                <div>
                    {isVideo ? (
                        <div>
                            <video
                                controls
                                playsInline
                                preload="metadata"
                                width={'1200px'}
                                style={{maxWidth: '100%'}}
                                onError={() => this.setState({videoLoadError: true})}
                                onLoadedData={() => this.setState({videoLoadError: false})}
                            >
                                <source src={this.state.public_url} type={sourceType} />
                                Your browser does not support the video tag.
                            </video>
                            {this.state.videoLoadError && (
                                <p>
                                    Video could not be played in preview. <a href={this.state.public_url} target="_blank" rel="noopener noreferrer" style={{ color: '#0066cc', textDecoration: 'underline' }}>Download video</a>.
                                </p>
                            )}
                        </div>
                    ) : (
                        <embed src={this.state.public_url} width={'1200px'} height={'1400px'} frameBorder={'0'}></embed>
                    )}

                </div>
            )
        } else {
            return (
                <div width={'100%'} height={'100%'}>
                    <p>File type not supported.</p>
                </div>

            )
        }
    }



    render() {
        return (
            <ArtifactDialog title="File Artifact" isReviewed={this.props.isReviewed} submission={this.props.submission} >
                {this.renderDescription()}
                <Divider variant="inset" />
                {this.showIframe()}
            </ArtifactDialog>
        )
    }
}

export default withMobileDialog()(Attachment);


